var exports = {
  "p_": "x8b4e8595--7c2701--list",
  "Vg": "x8b4e8595--7c2701--grid",
  "N_": "x8b4e8595--7c2701--grid-without-skeletons",
  "ld": "x8b4e8595--7c2701--items",
  "BA": "x8b4e8595--7c2701--shimmer-boundary",
};

module.exports = exports;
